import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../model/https';
import { ITrackPackageResponse } from '../../model/trackPackage.model';
import { TRACKPACKAGE } from '../../routes/routeConstants';
import useHttps from '../useHttps';

const useTrackPackages = () => {
  const request = useHttps();
  const navigate = useNavigate();
  const [trackPackageloading, setTrackPackageLoading] = useState(false);

  const onTrackPackagesError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ?? 'Error occured while tracking package'
    );
  };

  const onTrackPackagesSuccess = (packageId: string) => {
    navigate(`${TRACKPACKAGE}/${packageId}`);
  };

  const wrapOnTrackPackagesSuccess =
    (packageId: string) =>
    ({ message, data }: SuccessHttpResponse<ITrackPackageResponse>) =>
      onTrackPackagesSuccess(packageId);

  const trackPackages = (packageId: string) => {
    const url: HttpConfig = {
      url: `general-service/packages/${packageId}`,
      method: 'get',
    };

    request(
      url,
      wrapOnTrackPackagesSuccess(packageId),
      setTrackPackageLoading,
      onTrackPackagesError
    );
  };

  return { trackPackages, trackPackageloading };
};

export default useTrackPackages;
